module.exports = __webpack_public_path__ + "img/reading.65acff6b.png";